export default __webpack_public_path__ + "img/409db9b6fba0b213c888468b769dfed2.svg";